import { createAction } from "redux-actions";

export const RESEND_CONFIRMATION_EMAIL = "RESEND_CONFIRMATION_EMAIL";
export const RESEND_CONFIRMATION_EMAIL_SUCCESS =
  "RESEND_CONFIRMATION_EMAIL_SUCCESS";
export const RESEND_CONFIRMATION_EMAIL_FAILURE =
  "RESEND_CONFIRMATION_EMAIL_FAILURE";

export const resendEmailAction = createAction(RESEND_CONFIRMATION_EMAIL);
